import { Navigate, useLocation, useParams } from "react-router-dom";
import { PATH_DASHBOARD } from "./paths";

export function getHrmLegacyTarget(pathname, state, id) {
  const isRoles =
    pathname.startsWith("/dashboard/desigination") ||
    state?.activeTab === "desiginations";
  const section = isRoles ? PATH_DASHBOARD.desigination : PATH_DASHBOARD.user;
  const action = pathname.split("/").pop();
  if (action === "new") return section.new;
  if (id) {
    if (action === "edit") return section.edit(id);
    if (action === "replicate" && !isRoles) return section.replicate(id);
    return section.view(id);
  }
  return section.root;
}

export default function HrmLegacyRedirect() {
  const { pathname, state, search, hash } = useLocation();
  const { id } = useParams();
  return (
    <Navigate
      to={`${getHrmLegacyTarget(pathname, state, id)}${search}${hash}`}
      replace
    />
  );
}
